/**
 * MfaEnforcementBanner — Globales Grace-Period-Banner für Platform-Admins.
 *
 * No-op für Nicht-Admins, bereits enrollte Admins oder während des Ladens.
 * Zeigt verbleibende Tage bis MFA-Pflicht + Link zur Profil-Enrollment-Route.
 * Siehe: docs/frontend/FRONTEND-DESIGN-RULES.md
 */

import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useMfaStatus } from '@/hooks/useMfaStatus';
import { useSupabaseAuth } from '@/contexts/SupabaseAuthContext';
import { Alert, AlertDescription } from '@/components/v2/ui/Alert';
import { Button } from '@/components/v2/ui/Button';
import { EID } from '@/lib/element-ids.registry';

export function MfaEnforcementBanner() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { user } = useSupabaseAuth();
  const { status, isLoading } = useMfaStatus();

  if (isLoading || !user?.is_admin) return null;
  if (!status || status.enrolled) return null;

  const until = status.recovery_grace_until
    ? new Date(status.recovery_grace_until)
    : null;
  const days = until
    ? Math.max(0, Math.ceil((until.getTime() - Date.now()) / 86400000))
    : 0;

  return (
    <Alert
      data-testid="mfa-enforcement-banner"
      id={EID['mfa-enforcement-banner']}
      variant="warning"
      className="rounded-none border-x-0 border-t-0"
    >
      <AlertDescription className="flex items-center justify-between gap-3">
        <span>{t('mfa.banner.graceText', { days })}</span>
        <Button
          id={EID['mfa-banner-setup']}
          onClick={() => navigate('/v2/profile/mfa')}
        >
          {t('mfa.banner.setupNow')}
        </Button>
      </AlertDescription>
    </Alert>
  );
}
